<template>
    <transition name="el-zoom-in-center">
        <el-card v-show="resolveShow" class="box-card" style="text-align: left">
            <div slot="header" class="clearfix">
                <el-row>
                    <el-col :span="12">
                        <h3>分解工单</h3>
                    </el-col>
                    <el-col :span="12">
                        <el-button style="float: right" type="primary" @click="resolveShow = false">收起</el-button>
                    </el-col>
                </el-row>
            </div>
            <el-form ref="resolveForm" :model="resolveForm" label-width="110px" style="width: 100%" :rules="rules">
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="工单号" prop="orderno">
                            <el-input disabled v-model="form.orderno" style="width: 90%" placeholder="请输入工单号" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="产品编码" prop="product_name">
                            <el-input disabled v-model="form.product_name" style="width: 90%" placeholder="请输入产品编码" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="计划生产数量" prop="product_quantity">
                            <el-input disabled v-model.number="form.product_quantity" style="width: 90%"
                                placeholder="请输入计划生产数量" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="erp_id" prop="erp_id">
                            <el-input disabled v-model="form.erp_id" style="width: 90%" placeholder="请输入erp_id" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="计划生产日期">
                            <el-date-picker disabled style="width: 90%" v-model="form.plan_date" type="date"
                                value-format="yyyy-MM-dd" format="yyyy 年 MM 月 dd 日" placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row>
                    <!-- <el-col :span="6">
                        <el-form-item label="子工单" prop="subtask_order">
                            <el-input v-model="resolveForm.subtask_order" style="width: 90%" placeholder="请输入子工单编码" />
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="6">
                        <el-form-item label="分解数量" prop="resolve_quantity">
                            <el-input @change="quantityInput" v-model.number="resolveForm.resolve_quantity"
                                style="width: 90%" placeholder="请输入分解数量" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="计划生产日期" prop="plan_date">
                            <el-date-picker style="width: 90%" v-model="resolveForm.plan_date" type="date"
                                value-format="yyyy-MM-dd" format="yyyy 年 MM 月 dd 日" placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="备注" prop="remark">
                            <el-input v-model="resolveForm.remark" style="width: 90%" placeholder="请输入备注" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div>
                <!-- 填写具体奖项 -->
                <h4>原料分解列表</h4>
                <br />
                <el-row>
                    <el-col :span="16">
                        <el-card shadow="never">
                            <el-table :data="tablelist" stripe style="width: 100%" height="300">
                                <el-table-column prop="material_code" label="原料编码" min-width="150"
                                    show-overflow-tooltip />
                                <el-table-column prop="material_name" label="原料名称" min-width="150"
                                    show-overflow-tooltip />
                                <el-table-column prop="material_ratio" label="比例" show-overflow-tooltip
                                    min-width="80" />
                                <el-table-column prop="material_quantity" label="原料计划数量" min-width="150">
                                    <template slot-scope="scope">
                                        <el-input v-model.number="scope.row.material_quantity" style="width: 70%"
                                            placeholder="请输入原料计划数量" />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="material_batchno" label="原料批次" min-width="150">
                                    <template slot-scope="scope">
                                        <el-input v-model.number="scope.row.material_batchno" style="width: 70%"
                                            placeholder="请输入原料批次" />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" label="操作" width="160px" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button type="primary" @click.native.prevent="
                                            addRow(scope.$index, tablelist)
                                            ">增加</el-button>
                                        <el-button v-if="scope.row.type !== 1" type="danger" @click.native.prevent="
                                            deleteRow(scope.$index, tablelist)
                                            ">删除</el-button>

                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-card>
                    </el-col>
                </el-row>
                <div style="text-align: center">
                    <el-button style="margin-top: 12px" type="primary" @click="submitadd('resolveForm')">提交</el-button>
                </div>
            </div>
        </el-card>
    </transition>
</template>
<script>
import {
    workorderprocessingResolve,
} from "@/api/plant";
export default {
    props: {
        search: {
            type: Function,
            default: null,
        },
    },
    data() {
        return {
            resolveShow: false,
            form: {
                id: null,
                orderno: null,
                product_code: null,
                product_name: null,
                product_quantity: null,
                erp_id: null,
                plan_date: null,
                material_json: [],
            },
            resolveForm: {
                subtask_order: null,
                resolve_quantity: null,
                plan_date: null,
                remark: null,
            },
            // 步骤2表格数据
            tablelist: [],
            rules: {
                subtask_order: [
                    { required: true, message: "请输入子工单编码", trigger: "blur" },
                ],
                resolve_quantity: [
                    { required: true, message: "请输入分解数量", trigger: "blur", type: "number" },
                ],
                plan_date: [
                    { required: true, message: "请选择计划生产日期", trigger: "blur" },
                ],
                remark: [
                    { required: true, message: "请输入备注", trigger: "blur" },
                ],
            },
        };
    },
    watch: {
        'resolveShow': {
            handler(newValue, oldValue) {
                if (newValue) {
                    this.resetForm('resolveForm');
                    this.resolveForm = {}
                    this.form.product_name = this.form.product_code + " - " + this.form.product_name
                    this.tablelist = this.form.material_json.map(item => {
                        return {
                            material_ratio: item.material_ratio,
                            material_code: item.material_code,
                            material_name: item.material_name,
                            material_quantity: 0,
                            material_batchno: 0,
                            type: 1,
                        }
                    })
                }
            },
            deep: true
        },
    },
    methods: {
        quantityInput(val) {
            this.tablelist.forEach(item => {
                item.material_quantity = item.material_ratio * val
            })
            this.$forceUpdate()
        },
        // 表格行删除
        deleteRow(index, rows) {
            rows.splice(index, 1);
        },
        addRow(index, rows) {
            const obj = [rows[index]].map(item => {
                return {
                    material_code: item.material_code,
                    material_name: item.material_name,
                    material_ratio: item.material_ratio,
                    material_quantity: 0,
                    material_batchno: 0,
                    type: 0,
                }
            })[0]
            rows.splice(index + 1, 0, obj)
        },
        // 保存提交
        submitadd(formName) {
            this.$refs[formName].validate((valid) => {
                // 基础表单验证
                if (valid) {
                    if (this.tablelist.length == 0) {
                        this.$message({
                            type: "warning",
                            message: "请添加产品",
                        });
                        return
                    }
                    let params = this.resolveForm
                    params.materials = this.tablelist
                    params.id = this.form.id
                    workorderprocessingResolve(params).then((response) => {
                        if (response.status_code == 200) {
                            this.$message({
                                type: "success",
                                message: "添加成功!",
                            });
                            this.search();
                            this.tablelist = [];
                            this.resetForm(formName);
                            this.resolveShow = false;
                        } else {
                            this.$message({
                                type: "warning",
                                message: "添加失败!请检查字段",
                            });
                        }
                    });
                }
            });
        },
        // 清空表单数据
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
    },
};
</script>
<style lang="scss" scoped></style>